export const packages = [
  {
    id: 1,
    name: 'Discord Full Pack',
    description: 'Tam kapsamlı Discord sunucu yönetimi',
    features: [
      'Gelişmiş Moderasyon',
      'Guard',
      'Backup',
      'BlackList Sunucu Kontrolü',
      'Log Sunucusu İçin Yetkili Kontrolü'
    ],
    pricing: {
      monthly: { price: 750, original: 750 },
      sixMonth: { price: 3750, original: 4500 },
      yearly: { price: 7500, original: 9000 }
    }
  },
  {
    id: 2,
    name: 'Discord Pack',
    description: 'Temel Discord sunucu yönetimi',
    features: [
      'Gelişmiş Moderasyon',
      'Guard',
      'Backup'
    ],
    pricing: {
      monthly: { price: 500, original: 500 },
      sixMonth: { price: 2500, original: 3000 },
      yearly: { price: 5000, original: 6000 }
    }
  },
  {
    id: 3,
    name: 'Ekip Pack',
    description: 'Aile ve Çete ekipleri için en doğru seçim',
    features: [
      'Ekip Botu',
      'Guard ve Backup'
    ],
    pricing: {
      monthly: { price: 350, original: 350 },
      sixMonth: { price: 1750, original: 2100 },
      yearly: { price: 3500, original: 4200 }
    }
  },
  {
    id: 4,
    name: "Garry's Mod Full",
    description: "Tam kapsamlı Garry's Mod sunucu yönetimi",
    features: [
      'Gelişmiş Moderasyon',
      'Guard ve Backup',
      'Hızlı Giriş Sistemi',
      'Mesai Sistemi',
      'Başvuru Sistemi'
    ],
    pricing: {
      monthly: { price: 600, original: 600 },
      sixMonth: { price: 3000, original: 3600 },
      yearly: { price: 6000, original: 7200 }
    }
  },
  {
    id: 5,
    name: "Garry's Mod",
    description: "Temel Garry's Mod sunucu yönetimi",
    features: [
      'Moderasyon',
      'Guard ve Backup',
      'Hızlı Giriş Sistemi'
    ],
    pricing: {
      monthly: { price: 500, original: 500 },
      sixMonth: { price: 2500, original: 3000 },
      yearly: { price: 5000, original: 6000 }
    }
  },
  {
    id: 6,
    name: 'Legal Pack',
    description: 'Legal ekipler için en uygun paket',
    features: [
      'Mesai Botu',
      'Guard Botu'
    ],
    pricing: {
      monthly: { price: 350, original: 350 },
      sixMonth: { price: 1750, original: 2100 },
      yearly: { price: 3500, original: 4200 }
    }
  }
];

export const bots = [
  {
    id: 1,
    name: 'Moderasyon',
    description: 'Fivem, Garry\'s Mod, Public vb. Sunucular icin',
    features: [
      'Ticket Sistemi',
      'Kayıt Sistemi',
      'Ekip Sistemi',
      'Uyarı Sistemi',
      'Log Sistemi',
      'Gelişmiş Ceza ve Log sistemleri'
    ],
    pricing: {
      monthly: { price: 325, original: 325 },
      sixMonth: { price: 1625, original: 1950 },
      yearly: { price: 3250, original: 3900 }
    }
  },
  {
    id: 2,
    name: 'Guard',
    description: 'Discord Sunucunuz icin Gelismis koruma ve backup sistemi',
    features: [
      'Gelişmiş Koruma Sistemleri',
      'Ayarlanabilir güvenli listeler',
      'Backup sistemleri'
    ],
    pricing: {
      monthly: { price: 250, original: 250 },
      sixMonth: { price: 1250, original: 1500 },
      yearly: { price: 2500, original: 3000 }
    }
  },
  {
    id: 3,
    name: 'Ticket',
    description: 'Destek bileti sistemi',
    features: [
      'Gelişmiş Ticket Sistemi',
      'Kategori Sistemi',
      'Transcript Sistemi',
      'Log Sistemi'
    ],
    pricing: {
      monthly: { price: 150, original: 150 },
      sixMonth: { price: 750, original: 900 },
      yearly: { price: 1500, original: 1800 }
    }
  },
  {
    id: 4,
    name: 'Ekip Botu',
    description: 'Aile ve Cete ekipleri icin en ideal bot',
    features: [
      'Etkinlik sistemi',
      'Aktiflik sistemi',
      'Başvuru ve Ticket sistemleri',
      'Gelişmiş Loglar'
    ],
    pricing: {
      monthly: { price: 225, original: 225 },
      sixMonth: { price: 1125, original: 1350 },
      yearly: { price: 2250, original: 2700 }
    }
  },
  {
    id: 5,
    name: 'Mesai Botu',
    description: 'Legal ekipler icin en ideal bot',
    features: [
      'Mesai Sistemi',
      'Başvuru ve Ticket sistemi',
      'Gelişmiş Loglar'
    ],
    pricing: {
      monthly: { price: 225, original: 225 },
      sixMonth: { price: 1125, original: 1350 },
      yearly: { price: 2250, original: 2700 }
    }
  }
];

export const additionalServices = [
  {
    id: 1,
    name: 'Special Bot',
    description: 'Istege ozel sistemler',
    features: ['Isteklerinize en uygun cozumler'],
    price: 100,
    period: 'ay'
  },
  {
    id: 2,
    name: 'Yetkili Takip',
    description: 'Yetkili Takip',
    features: ['Log Sunucusu Guvenligi'],
    price: 150,
    period: 'ay'
  },
  {
    id: 3,
    name: 'Black List Sunucu',
    description: 'Black List Sunucu',
    features: [
      'Black List sunucuda bulunan kullanıcılara uyarı DM\'i',
      'Otomatik Yasaklama'
    ],
    price: 150,
    period: 'ay'
  },
  {
    id: 4,
    name: 'Webhook Koruması',
    description: 'Log sistemleri icin Webhook koruması',
    features: [
      'Gelismis IP koruma',
      'Detayli loglama',
      'Takim yonetimi',
      'Gelismis analitik'
    ],
    price: 250,
    period: 'ay'
  },
  {
    id: 5,
    name: 'Reklam 1 Haftalik',
    description: 'Swenzy Discordundan acilan bir kanal uzerinden belirttiniz text @everyone atilarak paylasilir',
    features: [
      '7 Gun kalir',
      'Istediginiz metin paylasilir',
      'Cekilis ekleyebilirsiniz'
    ],
    price: 400,
    period: 'Haftalık'
  },
  {
    id: 6,
    name: 'Reklam 1 Aylik',
    description: 'Swenzy Discordundan acilan bir kanal uzerinden belirttiniz text @everyone atilarak paylasilir',
    features: [
      '30 Gun kalir',
      'Istediginiz metin paylasilir',
      'Cekilis ekleyebilirsiniz'
    ],
    price: 1200,
    period: 'Ay'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Ahmet Y.',
    company: 'Tech Roleplay',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Ahmet',
    text: 'Kalite asla tesadüf değildir. Botlarıyla uzun süredir çalışıyoruz ve her geçen gün işimizin ne kadar kolaylaştığını görüyoruz. Kesinlikle tavsiye ediyoruz!'
  },
  {
    id: 2,
    name: 'Mehmet K.',
    company: 'Night Gaming',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mehmet',
    text: 'Swenzy ekibi, her konuda son derece ilgili ve destekleyici. Karşılaştığımız her sorunda hızlıca yanıt vererek en uygun çözümleri sunuyorlar.'
  },
  {
    id: 3,
    name: 'Zeynep A.',
    company: 'Nova Community',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Zeynep',
    text: 'Swenzy botlarını entegre ettiğimizden beri yönetim süreçlerimiz büyük ölçüde hızlandı. Gelişmiş loglama sistemi ekibimizin iş yükünü ciddi oranda hafifletti.'
  },
  {
    id: 4,
    name: 'Can D.',
    company: 'Phoenix RP',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Can',
    text: 'Sunucumuzda Swenzy botlarını kullanıyoruz ve gerçekten çok memnunuz. Güvenilirliği ve kalitesi bizim için çok önemliydi.'
  }
];

export const faqData = [
  {
    id: 1,
    question: 'Bot özelleştirilebilir mi?',
    answer: 'Evet, tüm botlarımız isteğinize göre özelleştirilebilir. İhtiyaçlarınıza uygun olarak komutlar, özellikler ve görünüm ayarlanabilir.'
  },
  {
    id: 2,
    question: 'Ödeme yöntemleri nelerdir?',
    answer: 'Visa/Mastercard banka havalesi ile ödeme kabul ediyoruz. Satın Al butonuna tıkladığınızda ödeme bilgilerimizi göreceksiniz.'
  },
  {
    id: 3,
    question: 'Bot kurulumu ne kadar sürer?',
    answer: 'Bot kurulumu genellikle 24 saat içerisinde tamamlanır. Özelleştirme isteklerinize bağlı olarak bu süre değişebilir.'
  },
  {
    id: 4,
    question: 'Teknik destek sağlıyor musunuz?',
    answer: 'Evet, 7/24 teknik destek sağlıyoruz. Discord sunucumuz üzerinden her zaman bize ulaşabilirsiniz.'
  },
  {
    id: 5,
    question: 'Botlar için garanti veriyor musunuz?',
    answer: 'Tüm botlarımız için tam garanti sağlıyoruz. Herhangi bir sorun yaşanması durumunda hızlıca müdahale ediyoruz.'
  }
];

export const stats = {
  onlineMembers: 979,
  totalMembers: 4108,
  totalCustomers: 560,
  staff: 10
};